import { playSound, Sound } from '~/assets/sounds';
import { IObservable } from '~/rage/utils';
import { IHudTaskProgress } from '~/shared';
import { BackendService } from '../BackendService';
import { VarsService } from '../VarsService';
import { IQuestsService } from './questsServiceTypes';

export class QuestsService implements IQuestsService {
	constructor(
		private readonly vars: VarsService,
		backend: BackendService,
	) {
		backend.addEventHandler(
			'playQuestRewardSound',
			(_payload: { questId: string }) => {
				playSound(Sound.FinalQuest);
			},
		);
	}

	public getHudTask(): IObservable<IHudTaskProgress | null> {
		return this.vars.get('quests:hudTask', null);
	}
}
